import { defineStore } from 'pinia'
import { Feature } from '../enums/feature'

interface State {
    features: Record<Feature, boolean>
}

export const useFeatureStore = defineStore('feature', {
    state: (): State => ({
        features: window.shared?.features ?? ({} as Record<Feature, boolean>),
    }),

    actions: {
        isEnabled(feature: Feature): boolean {
            return !!this.features[feature]
        },

        isDisabled(feature: Feature): boolean {
            return !this.features[feature]
        },
    },
})
